import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PositionRequest } from '../../../models/opportunity.model';
import { opportunityService } from '../../../services/opportunityService';
import { OPPORTUNITIES_QUERY_KEY } from './useOpportunitiesQuery';
import { opportunityQueryKey } from './useOpportunityQuery';

export const useAddPosition = (opportunityId: number) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: PositionRequest) => opportunityService.addPosition(opportunityId, data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: OPPORTUNITIES_QUERY_KEY });
            queryClient.invalidateQueries({ queryKey: opportunityQueryKey(opportunityId) });
        },
    });
};

export const useUpdatePosition = (opportunityId: number) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ positionId, data }: { positionId: number; data: PositionRequest }) =>
            opportunityService.updatePosition(opportunityId, positionId, data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: OPPORTUNITIES_QUERY_KEY });
            queryClient.invalidateQueries({ queryKey: opportunityQueryKey(opportunityId) });
        },
    });
};

export const useRemovePosition = (opportunityId: number) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (positionId: number) => opportunityService.removePosition(opportunityId, positionId),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: OPPORTUNITIES_QUERY_KEY });
            queryClient.invalidateQueries({ queryKey: opportunityQueryKey(opportunityId) });
        },
    });
};
